import React from "react";
import PropTypes from 'prop-types';

import SwipeableViews from 'react-swipeable-views';

//import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';

import CloseIcon from '@material-ui/icons/Close';
import DeleteIcon from '@material-ui/icons/Delete';
import FavoriteFull from '@material-ui/icons/Favorite';
import Favorite from '@material-ui/icons/FavoriteBorder';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';

import * as innerHeight from 'ios-inner-height';

import { withStyles } from '@material-ui/core/styles';

import GoogleAnalytics from '../Components/GoogleAnalytics';

const styles = theme => ({

    root: {
        backgroundColor: theme.palette.mediaDisplay.main,
        width: '100vw',
        flexGrow: 1,
        overflowY: 'scroll',
    },

    imageContainer: {
        backgroundColor: 'transparent',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100vw',
        height: '100vh',
    },

    image: {
        maxWidth: '85%',
        maxHeight: '85%',
        objectFit: 'contain',
        draggable: false,
      },      

    appbar: {
        background: 'linear-gradient(black,transparent)',
        color: theme.palette.mediaDisplay.contrastText,
        boxShadow: 'none',
    },

      dismissButton: {
          alignSelf: 'flex-start',
          marginLeft: -12,
          marginRight: 20,
      },

      spacer : {
          display: 'block',
          flex: 1,
      },

      destructiveButton : {
          color: 'red',
          borderColor: 'red',
      }
});

class MediaBrowser extends React.Component {

    constructor(props) {
        super(props);
        const { indexToStart } = this.props;        
        this.state = { currentIndex: indexToStart, navToIndex: indexToStart, deleteAlertOpen: false };
        console.log('MediaBrowser:constructor',this.props.mediaList.length, this.state.currentIndex, this.state.navToIndex);
        
    }

    componentDidMount() {
        GoogleAnalytics.event(GoogleAnalytics.CATEGORY.user,GoogleAnalytics.CAAZAM_EVENTS.photoView);
    }

    favoriteStatusForMedia(media) {
        if (media.subjectFeedback) {
            return media.subjectFeedback.favoriteStatus || false;
        } else {
            return false;
        }
    }

    static getDerivedStateFromProps(props, state) {
        let mediaCount = props.mediaList.length;
        
        // if the current index is invalid, move to the previous one
        if (state.currentIndex >= mediaCount) {
            const newIndex = props.mediaList.length - 1;
            console.error('MediaBrowser: index out of range, moving to',newIndex);
            return { currentIndex: newIndex, navToIndex: newIndex };
        }
        
        // adjust viewing index of currently viewed image when a new image is added 
        // TBD

        return null;
    }

    render() {
        const { selfUuid, mediaList, classes } = this.props;
        const { navToIndex, currentIndex } = this.state;

        console.log('MediaBrowser:render', mediaList.length, currentIndex, navToIndex)

        const heightForImage = innerHeight();
        console.log(`InnerHeight ${heightForImage}`);

        const currentFavStatus = this.favoriteStatusForMedia(mediaList[currentIndex]);
        const favDisabled = selfUuid === mediaList[currentIndex].photographerId;

        return (
            <div className={classes.root}>
                <AppBar className={classes.appbar} position='fixed'>
                    <Toolbar>
                        <IconButton className={classes.dismissButton} color='inherit' aria-label='Back' onClick={this.props.onCloseBrowser}>
                            <CloseIcon />
                        </IconButton>
                        <div className={classes.spacer} />
                        <IconButton disabled={favDisabled} color='inherit' aria-label='Favorite' onClick={(ev) => this.onFavStatusClick()}>
                            {currentFavStatus ? <FavoriteFull /> : <Favorite/>}
                        </IconButton>
                        <IconButton color='inherit' aria-label='Delete' onClick={this.handleDeleteAlertOpen}>
                            <DeleteIcon />
                        </IconButton>
                        {this.renderDeleteAlert(classes)}
                    </Toolbar>
                </AppBar>
                <SwipeableViews enableMouseEvents index={navToIndex} onChangeIndex={(index, indexLatest, meta) => this.onChangeIndex(index, indexLatest, meta)}>
                    {
                        mediaList.map((media, index) => (
                            <MediaBrowserPageWithStyles key={media.mediaUuid} media={media} index={index}/>
                        ))
                    }
                </SwipeableViews>
            </div>
        )
    }

    onChangeIndex(index,indexLatest,meta) {
        console.log(index,indexLatest,meta);
        GoogleAnalytics.event(GoogleAnalytics.CATEGORY.user,GoogleAnalytics.CAAZAM_EVENTS.photoView);
        this.setState( {currentIndex: index} );
    }

    onFavStatusClick() {
        let {currentIndex} = this.state;
        let currentFavStatus = this.favoriteStatusForMedia(this.props.mediaList[currentIndex]); 
        this.props.onFavStatusChange(currentIndex,!currentFavStatus);        
    }

    onDelete() {
        this.handleDeleteAlertClose();
        let { currentIndex } = this.state;
        this.props.onDelete(currentIndex);
    }

    renderDeleteAlert(classes) {
        return (
            <Dialog
                open={this.state.deleteAlertOpen}
                onClose={this.handleDeleteAlertClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Delete this image?
                </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleDeleteAlertClose} >
                        Cancel
            </Button>
                    <Button variant="outlined" className={classes.destructiveButton} onClick={() => this.onDelete()} autoFocus>
                        Delete
            </Button>
                </DialogActions>
            </Dialog>
        )
    }

    handleDeleteAlertOpen = () => {
        this.setState({ deleteAlertOpen: true });
    };

    handleDeleteAlertClose = () => {
        this.setState({ deleteAlertOpen: false });
    };
}

MediaBrowser.propTypes = {
    mediaList: PropTypes.array.isRequired,
    indexToStart: PropTypes.number.isRequired,
    onCloseBrowser: PropTypes.func.isRequired,
    onDelete: PropTypes.func,
};

const MediaBrowserPage = (props) => {
    let { media, classes } = props;
    const imageSize = media.publicUrls.size_web || media.publicUrls.size_orig;
    return (
        <div className={classes.imageContainer}>
            <img className={classes.image} src={imageSize.url} alt={media.mediaUuid} draggable='false'/>
        </div>
    )
}

MediaBrowserPage.propTypes = {
    media: PropTypes.object.isRequired,
    index: PropTypes.number.isRequired,
};

const MediaBrowserPageWithStyles = withStyles(styles)(MediaBrowserPage)

export default withStyles(styles)(MediaBrowser);


// WEBPACK FOOTER //
// ./src/Components/MediaBrowser.js